var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.comp)?_c(_vm.comp,_vm._g(_vm._b({tag:"component",attrs:{"req":_vm.req},on:{"on-close":function($event){return _vm.$emit('on-close')}}},'component',_vm.$attrs,false),_vm.$listeners)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }